export default "__VITE_ASSET__atB4bn7g__"